import { KeyboardShortcut } from '@rematter/ui-web';

const isMac = globalThis.navigator.userAgent.includes('Macintosh');

export const keymap: Record<string, KeyboardShortcut> = {
  save: isMac ? 'Meta+Enter' : 'Ctrl+Enter',
};
